import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { DataBagService } from 'src/app/common/data-bag.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { PricePipe } from 'src/app/common/pipes/price.pipe';
import { OrganizationService } from 'src/app/organization/organization/organization.service';

@Component({
	selector: 'app-organization-dialog-add',
	templateUrl: './organization-dialog-add.component.html',
	styleUrls: ['./organization-dialog-add.component.scss'],
})
export class OrganizationDialogAddComponent implements OnInit {
	@ViewChild('dataTableAddress') tableAddress: MatTable<any>;
	@ViewChild('dataTableContacts') tableContacts: MatTable<any>;
	pageFunction = 'add';
	matDataAddress = new MatTableDataSource<any>();
	matDataContacts = new MatTableDataSource<any>();
	protected apiUrlAdd = '/organization/';
	protected apiUrl = '/organization/';
	protected errors = {
		shortName: null,
		name: null,
		regon: null,
	};
	addressColumns: string[] = ['address', 'zipCode', 'location', 'kind'];

	contactColumns: string[] = ['department', 'departmentNumber', 'departmentEmail', 'userResponsibility'];

	cooperationSet = [
		{
			key: 'CO',
			value: 'Stała',
		},
		{
			key: 'OC',
			value: 'Okazjonalna',
		},
	];

	constructor(
		protected loader: LoaderService,
		protected infobox: InfoboxService,
		protected route: ActivatedRoute,
		protected router: Router,
		private readonly bag: DataBagService,
		private readonly pricePipe: PricePipe,
		public service: OrganizationService,
		public dialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.matDataAddress.data = this.service.organizationData.address;
	}

	submitOrganization() {
		this.loader.show();
		switch (this.pageFunction) {
			case 'add':
				this.doAdd(this.dataSendGenerate());
				break;
		}
	}

	private dataSendGenerate() {
		return {
			id: null,
			shortName: this.service.organizationData.shortName,
			name: this.service.organizationData.name,
			sellCategory: this.service.organizationData.sellCategory,
			codeMerlinx: this.service.organizationData.codeMerlinx,
			regon: this.service.organizationData.regon,
			nip: this.service.organizationData.nip,
			krs: this.service.organizationData.krs,
			nawigatorID: this.service.organizationData.nawigatorID,
			isOskar: this.service.organizationData.isOskar,
			address: this.service.organizationData.address.map((singleAddress) => {
				return {
					location: singleAddress.location?.id,
					address: singleAddress.address,
					zip_code: singleAddress.zipCode,
					kind: singleAddress.kind,
				};
			}),
			departments: this.service.organizationData.departments,
			balance: this.service.organizationData.balance,
			kind_cooperation: this.service.organizationData.kindCooperation,
		};
	}

	private doAdd(dataSend) {
		this.bag.post(this.apiUrlAdd, dataSend, (result, error) => {
			this.service.organizationData.id = result.id;
			this.afterSend(result, error);
		});
	}

	private afterSend(result, error) {
		this.loader.hide();
		if (error) {
			let hasErrors = false;
			for (const key in this.errors) {
				if (error.error.name[0].includes('already exists'))
					this.infobox.error('Organizacja o takiej nazwie już istnieje');
				if (!this.dataSendGenerate()[key]) {
					this.errors[key] = true;
					hasErrors = true;
					continue;
				}
				this.errors[key] = false;
				return;
			}
			return;
		}
		this.infobox.success('Zapisano');
	}

	convertBalabce(balance: number) {
		return this.pricePipe.transform(balance);
	}

	getKind(item) {
		return this.service.enterpriseData.addressKind.find((findObj) => findObj.id === item)?.kind;
	}

	getUser(userId) {
		return this.service.enterpriseData.departmentUsers?.find((user) => user.id === userId)?.email;
	}

	getDepartmentKind(item) {
		return this.service.enterpriseData.departmentKinds?.find((findDep) => findDep.id === item)?.name;
	}
}
